// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { DialogProvider } from './components/DialogProvider';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error("Failed to find #root element");
}

// createRoot replaces ReactDOM.render in React 18
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <DialogProvider>
      <App />
    </DialogProvider>
  </React.StrictMode>
);  